export default "__VITE_ASSET__OWY$BaiO__"